import { Api } from "./classes/Api";
import { Course } from "./classes/Course";
import { Website } from "./classes/Website";
import { CmsItem, ICourse } from "./schema";

const website = new Website();
const api = new Api();

api.getItem(121, courseFetched);

website.setEmptyState();

function courseFetched(data: CmsItem<ICourse, any>) {
  if (
    data &&
    data.data &&
    data.children &&
    Array.isArray(data.children) &&
    website.aside
  ) {
    website.setCourseTitle(data.data.Name);
    let mode: "edit" | "preview" | "live" = "edit";
    if (website.pageId === "preview") mode = "preview";
    const course = new Course(data, website.aside, mode);
  } else {
    console.error("Invalid data format:", data);
  }
}
